import { useEffect } from "react";
import { logIframeActivity, setIframeActivityUser } from "src/helpers/iframeActivity";

// Tracker event type -> activity action.
const ACTIONS = {
  change: "FIELD_UPDATE",
  submit: "FORM_SUBMIT",
  drag_start: "DRAG_START",
  drop: "DRAG_AND_DROP",
  route: "NAVIGATION_CHANGE",
  api: "API_CALL",
  data_change: "DATA_UPDATE",
  ui_change: "SCREEN_CHANGE",
};

/**
 * Receives events from the in-app tracker (public/cs-iframe-tracker.js) for every iframe on the page, and hands them to
 * iframeActivity, which stores the important ones. Events sent by apps that still have an older copy of the tracker,
 * clicks included, are dropped there.
 */
export function useIframeTrackerLogger(user) {
  useEffect(() => {
    setIframeActivityUser(user);
  }, [user]);

  useEffect(() => {
    const handleMessage = (event) => {
      const data = event.data;
      if (data?.source !== "cs-tracker") return;
      // Only accept events from iframes on this page.
      const iframe = Array.from(document.querySelectorAll("iframe")).find((frame) => frame.contentWindow === event.source);
      if (!iframe) return;
      logIframeActivity({
        action: ACTIONS[data.type] || String(data.type).toUpperCase(),
        summary: data.summary,
        details: data.data || {},
        iframe,
        origin: event.origin,
        appPath: data.path,
        eventTime: data.at,
      });
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
}
